import React from 'react';
import '../less/Slider.less';
import {Link, Slider} from 'MWC';
import { environment } from "../../../../environment/environment";

export default function template() {

    const { isMobile, lang, widget, hardSlide  } = this.props,
      sortedWidget = this.filterSlidesByEnvironment(widget.data),
      slides = widget.data ? sortedWidget.sort((a, b) => a.order - b.order).map((item) => {
        const bgImage = isMobile ? this.changeFilesUrl(item.img_mobile) : this.changeFilesUrl(item.img_desktop);
        const itemHeight = item.height_px ? item.height_px : 0
        return (
          <div className={`slide slider-main `} key={item.id} style={{
            background: `url(${bgImage}) center / contain no-repeat`, backgroundSize:'cover'}}>
            <div className='slide-content' style={{
                ...(isMobile
                    ? { justifyContent: "start" }
                    : item.height_px_desk
                    ? { alignItems: "start" }
                    : { alignItems: "center" }),
              }}>
              <div className='green-content' style={{
                  marginTop: isMobile
                    ? `${item.height_px_mob || 100}px`
                    : `${item.height_px_desk || 0}px` 
                }}>
                <div className='slider-main-head'
                     dangerouslySetInnerHTML={{ __html: item.title_ua}}>
                </div>
                <div className='slider-desc'
                     dangerouslySetInnerHTML={{ __html: isMobile ? item.desc_mobile : item.desc_desktop}}></div>
                  {item.btn_status ?
                    <div className='slider-info'>
                      <Link href={item.btn_path === '#credit-calculator' ? '' : (item.btn_path ? item.btn_path : `${this.changeFilesUrl(item.btn_file)}`)} target="_self" onClick={item.btn_path === '#credit-calculator' ? (e) => e.preventDefault() : undefined}>
                          <button className={item.button_white ? 'btn-transparent' : 'btn-black'} onClick={(e) => item.btn_path === '#credit-calculator' ? this.props.toggleModal(false) : undefined}>
                            {item.button_title ? item.button_title : this.l10n('BANNER_CASHBACK_OSGPO_BUTTON')}
                          </button>
                      </Link>
                    </div>
                  : ''}
              </div>
            </div>
            <div className="footnote" dangerouslySetInnerHTML={{ __html: item.share_ua}}></div>
          </div>
        )
      }) : [];
    return (
      <div className='side-a slider-wrapper'>
        <Slider
          autoPlayInterval={15000000}
          autoPlay
          showNavigation={slides.length > 1}
          showArrows={slides.length > 1}
        >
          {slides}
        </Slider>
      </div>
    );
}
